import { render, staticRenderFns } from "./EditProjects.vue?vue&type=template&id=436e5826&"
import script from "./EditProjects.vue?vue&type=script&lang=js&"
export * from "./EditProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports